import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostHonorarVereinbarungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostHonorarVereinbarungCommandService],
  exports: []
})
export class PostHonorarVereinbarungCommandServiceModule { }
